// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2yElf","paramInput":"JobSimulator_paramInput__2tjmW","input":"JobSimulator_input__1SRaf"};